export default __webpack_public_path__ + "static/Flor_de_lino-e02bd0a11609fa496ae08b1ab8478ae8.mp3";